type UserData = {
  signedIn?:boolean
  isPro?:boolean
  authId?:string
  feedbackProvided?:string
  enabledFlags?:string[]
  splitTestName?:string
  splitTestVariant?:string
}

export interface IUserData extends UserData {
  userData:UserData
  init: () => void
  modifyData: (_modifiedData:UserData) => void
}

class EzUser implements IUserData {
  userData = null;

  signedIn = false;

  isPro = false;

  authId = null;

  feedbackProvided = null;

  enabledFlags = [];

  splitTestName = null;

  splitTestVariant = null;

  private parseData = () => {
    this.userData = JSON.parse(document.body.dataset.userData);

    this.signedIn = this.userData.signedIn || false;

    this.isPro = this.userData.isPro || false;

    this.authId = this.userData.authId || null;

    this.feedbackProvided = this.userData.feedbackProvided || null;

    this.enabledFlags = this.userData.enabledFlags || [];

    [this.splitTestName, this.splitTestVariant] = this.userData.currentSplitTest.split(':') || [null, null];
  };

  public init() {
    this.parseData();

    window.addEventListener('turbolinks:render', this.parseData);
  }

  public modifyData(modifiedData:UserData) {
    const modifiedUserData = { ...this.userData, ...modifiedData };

    document.body.dataset.userData = JSON.stringify(modifiedUserData);

    this.parseData();
  }

  public enableFlagForTest(enabledFlag:string) {
    this.modifyData({ enabledFlags: [...this.enabledFlags, enabledFlag] });
  }

  public disableFlagForTest(disabledFlag:string) {
    this.modifyData({ enabledFlags: this.enabledFlags.filter((flag) => flag !== disabledFlag) });
  }
}

export default EzUser;
